module.exports = __webpack_public_path__ + "static/media/google.e99543bb.svg";